import type { ECurrency, ETableLimit } from '../../../../types/enums'
import { tableLimitsByBigBlind } from '../constants'

export const calcTableLimit = (
  currency:
    | typeof ECurrency.USDT
    | typeof ECurrency.COIN
    | typeof ECurrency.TON,
  bigBlind: number,
): ETableLimit | null => {
  const tableLimit = Object.entries(tableLimitsByBigBlind[currency]).find(
    ([limit, treshold]) => {
      if (bigBlind < treshold) {
        return true
      }
    },
  )
  if (!tableLimit) {
    return null
  }
  return tableLimit[0] as ETableLimit
}
